import { TextField } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import React from "react";
import { useTranslation } from "react-i18next";
import { getAlertType } from "../../Utils/Common";

export default function AlertDialog({ alertData, handleAnswer, setNote }) {
  const { alert, index } = alertData;
  const { t } = useTranslation();

  return (
    <Dialog
      open={alert ? true : false}
      onClose={() => {
        handleAnswer(alert, index, false);
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {getAlertType(alert.alertType, t)}
      </DialogTitle>
      <DialogContent>
        {alert.alertType === 0 ? (
          <DialogContentText id="alert-dialog-description">
            {alert.message ? t("alertDialog." + alert.message) : null}
          </DialogContentText>
        ) : null}
        <TextField
          label={t("alertDialog.addNote")}
          onChange={(e) => setNote(e.target.value)}
        ></TextField>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            handleAnswer(alert, index, false);
          }}
          color="primary"
        >
          {t("alertDialog.disagree")}
        </Button>
        <Button
          onClick={() => {
            handleAnswer(alert, index, true);
          }}
          color="primary"
          autoFocus
        >
          {t("alertDialog.agree")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
